import React, { useEffect, useMemo, useRef, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { fetchjockey } from "../../../redux/getReducer/getJockeySlice";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { fetchHorseForRace } from "../../../redux/getDropDownReducer/getHorseRace";
import { fetchequipment } from "../../../redux/getReducer/getEquipment";
import { fetchEditRaceHorse } from "../../../redux/getReducer/getEditHorseRaceSlice";
import Form from "react-bootstrap/Form";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import swal from "sweetalert";
import axios from "axios";
import { fetchColorDropdown } from "../../../redux/getDropDownReducer/getColor";
import { fetchsilkcolordropdown } from "../../../redux/getDropDownReducer/getOwnerSilkColor";
import { ImCross } from "react-icons/im";
import { TiTick } from "react-icons/ti";
import { fetchJockeyForRace } from "../../../redux/getDropDownReducer/getJockeyForRace";
import { fetchequipmentdropdown } from "../../../redux/getDropDownReducer/getEquipment";
import moment from "moment";

const AI_POLL_INTERVAL_MS = 5000;
const AI_POLL_LIMIT_MS = 15 * 60 * 1000;

/** Matches backend `parsedPayload.horses` keys from runRaceAiAnalysis.js */
const AI_HORSE_FIELD_ORDER = [
  "horseName",
  "winPct",
  "overallScore",
  "form",
  "classScore",
  "dist",
  "trainer",
  "jockey",
  "combo",
  "wet",
  "speed",
  "draw",
  "wt",
  "pedigree",
  "equip",
  "train",
  "bigRace",
  "age",
  "sex",
  "days",
  // v2 (prompts.js 2.2) keys
  "beaten",
  "classFit",
  "course",
  "surface",
  "going",
  "pace",
  "fitness",
  "ageSex",
  "dataStatus",
  "confidence",
  "riskFlags",
];

const AI_HORSE_LABELS = {
  horseName: "Horse",
  winPct: "Win %",
  overallScore: "Overall",
  form: "Form",
  classScore: "Class",
  dist: "Dist",
  trainer: "Trainer",
  jockey: "Jockey",
  combo: "Combo",
  wet: "Wet",
  speed: "Speed",
  draw: "Draw",
  wt: "Wt",
  pedigree: "Pedigree",
  equip: "Equip",
  train: "Train",
  bigRace: "Big race",
  age: "Age",
  sex: "Sex",
  days: "Days",
  classFit: "Class",
  ageSex: "Age/Sex",
};

function buildAiHorseColumnKeys(sampleRow) {
  if (!sampleRow || typeof sampleRow !== "object") return [];
  const keys = [];
  const seen = new Set();
  for (const k of AI_HORSE_FIELD_ORDER) {
    if (Object.prototype.hasOwnProperty.call(sampleRow, k)) {
      keys.push(k);
      seen.add(k);
    }
  }
  for (const k of Object.keys(sampleRow)) {
    if (!seen.has(k)) {
      keys.push(k);
      seen.add(k);
    }
  }
  return keys;
}

function labelAiHorseColumn(key) {
  if (AI_HORSE_LABELS[key]) return AI_HORSE_LABELS[key];
  return key
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (c) => c.toUpperCase())
    .trim();
}

function formatAiHorseCell(key, value) {
  if (value === null || value === undefined || value === "") return "—";
  if (key === "horseName") return String(value);
  if (key === "winPct") {
    const n = Number(value);
    return Number.isFinite(n) ? `${n.toFixed(2)}%` : "—";
  }
  const n = Number(value);
  if (Number.isFinite(n)) return n.toFixed(2);
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
}

const EditRaceHorse = () => {
  const [InputData, SetinputData] = useState("");
  const [IncreasePage, setIncreasePage] = useState(16);
  const [IncreasePage1, setIncreasePage1] = useState(16);
  const [Gate, setGate] = useState("");
  const [EquipmentData, SetEquipmentData] = useState("");
  const [JockeyData, SetJockeyData] = useState("");

  const [CapColor, SetCapColor] = useState("");
  const [HorseStatus, SetHorseStatus] = useState(true);
  const [items, setitems] = useState([]);
  const [HorseData, SetHorseData] = useState("");
  const [value1, SetValue1] = useState();

  const { data: EditRaceHorse } = useSelector((state) => state.EditRaceHorse);
  const { data: JockeyForRace } = useSelector((state) => state.JockeyForRace);
  const { data: HorseForRace } = useSelector((state) => state.HorseForRace);
  const { data: equipmentdropdown } = useSelector((state) => state.equipmentdropdown);
  const { data: colordropdown } = useSelector((state) => state.colordropdown);
  const { data: silkcolordropdown } = useSelector((state) => state.silkcolordropdown);

  const [SearchAge, setSearchAge] = useState("");
  const [SearchCode, setSearchCode] = useState("");
  const [SearchTitle, setSearchTitle] = useState("");
  const [SearchNameEn, setSearchNameEn] = useState("");
  const [SearchRating, setSearchRating] = useState("");

  const [RaceWeight, setRaceWeight] = useState("");
  const [aiLoading, setAiLoading] = useState(false);
  const [showAiAnalysisModal, setShowAiAnalysisModal] = useState(false);
  const [aiAnalysisLoading, setAiAnalysisLoading] = useState(false);
  const [aiAnalysisError, setAiAnalysisError] = useState(null);
  const [aiAnalysisRow, setAiAnalysisRow] = useState(null);
  const aiAnalysisRequestRef = useRef({ id: 0, controller: null });
  const aiPollRef = useRef(null);
  const history = useNavigate();
  const { state } = useLocation();
  const { RaceId } = state;

  const [StoreData, setStoreData] = useState([]);

  const slider = document.querySelector(".horizontal-scroll-wrapper");
  let isDown = false;
  let startX;
  let scrollLeft;
  if (slider) {
    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      slider.classList.add("active");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener("mouseleave", () => {
      isDown = false;
      slider.classList.remove("active");
    });
    slider.addEventListener("mouseup", () => {
      isDown = false;
      slider.classList.remove("active");
    });
    slider.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 3;
      slider.scrollLeft = scrollLeft - walk;
    });
  }

  const H1 = EditRaceHorse.map((item) => item.HorseNo);
  const HighNum = Math.max(...H1);
  let IncreseData = HighNum + 1;
  const [HorseNo, setHorseNo] = useState(1);

  let MapGate = [];
  for (var i = 1; i < 100; i++) {
    MapGate.push({ id: i, value: i, label: i });
  }

  const A1 = EditRaceHorse.map((item) => item.HorseModelId);

  let horseoptions = HorseForRace.map(function (item) {
     const age = item?.DOB
    ? moment().diff(moment(item.DOB), "years")
    : null;
    return {
      id: item._id,
      value: item.NameEn,
      label: item.NameEn,
      ActiveTrainerData: item?.ActiveTrainerData?.NameEn,
      DOB:`${age} Years`,
      ActiveOwnerid: item.ActiveOwner === null ? <></> : item.ActiveOwner,
      Ownername:
        item.ActiveOwnerData === null ? <>NAN</> : item.ActiveOwnerData.NameEn,
      rating: item.STARS,
      isdisabled:
        A1[0] !== item._id &&
          A1[1] !== item._id &&
          A1[2] !== item._id &&
          A1[3] !== item._id &&
          A1[4] !== item._id &&
          A1[5] !== item._id &&
          A1[6] !== item._id &&
          A1[7] !== item._id &&
          A1[8] !== item._id &&
          A1[9] !== item._id &&
          A1[10] !== item._id &&
          A1[11] !== item._id &&
          A1[12] !== item._id &&
          A1[13] !== item._id &&
          A1[14] !== item._id &&
          A1[15] !== item._id &&
          A1[16] !== item._id &&
          A1[17] !== item._id &&
          A1[18] !== item._id &&
          A1[19] !== item._id &&
          A1[20] !== item._id &&
          A1[21] !== item._id
          ? false
          : true,
    };
  });

  const G1 = EditRaceHorse.map((item) => item.GateNo);

  let Gateoptions = MapGate.map(function (item) {
    return {
      id: item._id,
      value: item.value,
      label: item.value,
      isdisabled:
        G1[0] !== item.value &&
          G1[1] !== item.value &&
          G1[2] !== item.value &&
          G1[3] !== item.value &&
          G1[4] !== item.value &&
          G1[5] !== item.value &&
          G1[6] !== item.value &&
          G1[7] !== item.value &&
          G1[8] !== item.value &&
          G1[9] !== item.value &&
          G1[10] !== item.value &&
          G1[11] !== item.value &&
          G1[12] !== item.value &&
          G1[13] !== item.value &&
          G1[14] !== item.value &&
          G1[15] !== item.value &&
          G1[16] !== item.value &&
          G1[17] !== item.value &&
          G1[18] !== item.value &&
          G1[19] !== item.value &&
          G1[20] !== item.value
          ? false
          : true,
    };
  });



  const J1 = EditRaceHorse.map((item) => item.JockeyOnRace);

  let AllJockey = JockeyForRace.map(function (item) {
    return {
      id: item._id,
      value: item._id,
      label: item.NameEn,
      weight: item.JockeyAllowance,
      minweight: item.MiniumumJockeyWeight,
      isdisabled:
        J1[0] !== item._id &&
          J1[1] !== item._id &&
          J1[2] !== item._id &&
          J1[3] !== item._id &&
          J1[4] !== item._id &&
          J1[5] !== item._id &&
          J1[6] !== item._id &&
          J1[7] !== item._id &&
          J1[8] !== item._id &&
          J1[9] !== item._id &&
          J1[10] !== item._id &&
          J1[11] !== item._id &&
          J1[12] !== item._id &&
          J1[13] !== item._id &&
          J1[14] !== item._id &&
          J1[15] !== item._id &&
          J1[16] !== item._id &&
          J1[17] !== item._id &&
          J1[18] !== item._id &&
          J1[19] !== item._id &&
          J1[20] !== item._id
          ? false
          : true,
    };
  });

  let AllEquipment = equipmentdropdown.map(function (item) {
    return {
      id: item._id,
      value: item.NameEn,
      label: item.NameEn,
    };
  });

  const dispatch = useDispatch();
  const AOwnerid = HorseData?.ActiveOwnerid || null;

  useEffect(() => {
    dispatch(fetchHorseForRace({ RaceId, IncreasePage }))
  }, [IncreasePage, RaceId, dispatch])
  useEffect(() => {

    dispatch(fetchJockeyForRace({ value1, IncreasePage1 }));
  }, [IncreasePage1, dispatch, value1])

  useEffect(() => {

    dispatch(fetchEditRaceHorse({ RaceId }));
    dispatch(fetchequipmentdropdown());
    dispatch(fetchColorDropdown());
    setHorseNo(IncreseData);
  }, [
    IncreseData,
    RaceId,
    SearchAge,
    SearchCode,
    SearchNameEn,
    SearchRating,
    SearchTitle,
    dispatch,
  ]);

  useEffect(() => {
    if (!AOwnerid) {
      SetCapColor(null);
      return;
    }
    dispatch(fetchsilkcolordropdown({ AOwnerid }));
  }, [dispatch, AOwnerid]);

  let AllsilkColor = silkcolordropdown.map(function (item) {
    return {
      id: item._id,
      value: item._id,
      urlimg: item.OwnerSilkColor,
      label: (
        <img src={item.OwnerSilkColor} height="30px" width="30px" alt="" />

      ),
    };
  });

  const getOwnerIdForCapColor = (item) => {
    return (
      HorseData?.ActiveOwnerid ||
      item?.OwnerOnRace ||
      item?.HorseModelIdData1?.ActiveOwner ||
      null
    );
  };

  const handleCapColorMenuOpen = (item) => {
    const ownerId = getOwnerIdForCapColor(item);
    if (!ownerId) {
      SetCapColor(null);
      return;
    }
    dispatch(fetchsilkcolordropdown({ AOwnerid: ownerId }));
  };

  useEffect(() => {
    if (!silkcolordropdown?.length) {
      SetCapColor(null);
      return;
    }
    const defaultSilk = silkcolordropdown.find((item) => item.isDefault) || silkcolordropdown[0];
    const selectedId = CapColor?.id;
    const hasSelectedInCurrentList = selectedId
      ? silkcolordropdown.some((item) => item._id === selectedId)
      : false;

    if (!hasSelectedInCurrentList && defaultSilk) {
      SetCapColor({
        id: defaultSilk._id,
        value: defaultSilk._id,
        urlimg: defaultSilk.OwnerSilkColor,
        label: <img src={defaultSilk.OwnerSilkColor} height="30px" width="30px" alt="" />,
      });
    }
  }, [silkcolordropdown, CapColor?.id]);

  useEffect(() => {
    localStorage.setItem("lists", JSON.stringify(items));
    localStorage.setItem("mapping", JSON.stringify(StoreData));
  }, [items, InputData, StoreData]);

  console.log(EditRaceHorse, 'EditRaceHorse')
  const saveEditItem = async (event, data) => {
    event.preventDefault();
    const formData = new FormData();
    let a = {
      GateNo: undefined,
      HorseNo: undefined,
      HorseModelId: undefined,
      Equipment: undefined,
      JockeyOnRace: undefined,
      JockeyWeight: undefined,
      Rating: undefined,
      HorseRunningStatus: undefined,
      CapColor: undefined,
      JockeyRaceWeight: undefined,
    };
    // eslint-disable-next-line array-callback-return
    EditRaceHorse.map((singleentry) => {
      if (singleentry._id === data) {
        a.GateNo = singleentry.GateNo;
        a.HorseModelId = singleentry.HorseModelId;
        a.Equipment = singleentry.Equipment;
        a.HorseNo = singleentry.HorseNo;
        a.JockeyOnRace = singleentry.JockeyOnRace;
        a.JockeyWeight = singleentry.JockeyWeight;
        a.GateRatingNo = singleentry.GateRatingNo;
        a.Rating = singleentry.Rating;
        a.HorseRunningStatus = singleentry.HorseRunningStatus;
        a.CapColor = singleentry.CapColor;
        a.JockeyRaceWeight = singleentry.JockeyRaceWeight;
      }
    });
    formData.append("GateNo", Gate.value === undefined ? a.GateNo : Gate.value);
    formData.append("HorseNo", a.HorseNo);
    formData.append(
      "HorseModelId",
      HorseData.id === undefined ? a.HorseModelId : HorseData.id
    );
    formData.append(
      "JockeyRaceWeight",
      RaceWeight === undefined ? a.JockeyRaceWeight : RaceWeight
    );
    if (EquipmentData.id !== undefined) {
      formData.append(
        "Equipment",
        EquipmentData.id === undefined ? a.Equipment : EquipmentData.id
      );

    }
    if (JockeyData.id !== undefined) {
      formData.append(
        "JockeyOnRace",
        JockeyData.id === undefined ? a.JockeyOnRace : JockeyData.id
      );
    }


    if (a.JockeyWeight !== null || JockeyData.weight !== undefined) {
      formData.append(
        "JockeyWeight",
        JockeyData.weight === undefined ? a.JockeyWeight : JockeyData.weight
      );
    }

    formData.append(
      "Rating",
      HorseData.rating === undefined ? a.Rating : HorseData.rating
    );
    formData.append(
      "HorseRunningStatus",
      HorseStatus === undefined ? a.HorseRunningStatus : HorseStatus
    );
    if (CapColor.id !== undefined) {
      formData.append(
        "CapColor",
        CapColor.id === undefined ? a.CapColor : CapColor.id
      );
    }

    formData.append("Rowid", data);

    try {
      await axios.put(
        `${window.env.API_URL}/EditRaceHorses/${RaceId}`,
        formData
      );
      localStorage.removeItem("lists");
      setGate(1);
      swal({
        title: "Success",
        text: "Data has been added successfully ",
        icon: "success",
        button: "OK",
      });
      dispatch(fetchEditRaceHorse({ RaceId }));
      // window.location.reload();
    } catch (error) {
      const err = error.response.data.message;
      swal({
        title: "Error!",
        text: err,
        icon: "error",
        button: "OK",
      });
    }
  };

  const handleRemove = async (Id) => {
    try {
      swal({
        title: "Are you sure?",
        text: "do you want to delete this data ?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          await axios.delete(`${window.env.API_URL}/DeleteRaceHorse/${Id}`);
          swal("Your data has been deleted Successfully!", {
            icon: "success",
          });
          dispatch(fetchEditRaceHorse({ RaceId }));
        } else {
          swal("Your data is safe!");
        }
      });
    } catch (error) {
      const err = error.response.data.message;
      swal({
        title: "Error!",
        text: err,
        icon: "error",
        button: "OK",
      });
    }
  };

  const addMore = (e) => {
    history("/editmorehorse", {
      state: {
        RaceId: RaceId,
      },
    });
  };

  const handleOnScrollBottom = () => {
    setIncreasePage(IncreasePage + 12)
    dispatch(fetchHorseForRace({ RaceId, IncreasePage }))
  };

  const handleOnScrollBottom1 = () => {
    setIncreasePage1(IncreasePage1 + 12)
    dispatch(fetchJockeyForRace({ value1, IncreasePage1 }));
  };

  const handleChangeInput1 = (value) => {
    SetValue1(value);
  };

  const sortedAiHorses = useMemo(() => {
    const horses = aiAnalysisRow?.parsedPayload?.horses;
    if (!Array.isArray(horses)) return [];
    return [...horses].sort(
      (a, b) => (Number(b.winPct) || 0) - (Number(a.winPct) || 0)
    );
  }, [aiAnalysisRow]);

  const aiHorseColumnKeys = useMemo(
    () => buildAiHorseColumnKeys(sortedAiHorses[0]),
    [sortedAiHorses]
  );

  useEffect(() => {
    return () => {
      aiAnalysisRequestRef.current.controller?.abort();
    };
  }, []);

  const openAiAnalysisModal = async () => {
    if (!RaceId) return;
    aiAnalysisRequestRef.current.controller?.abort();
    const requestId = aiAnalysisRequestRef.current.id + 1;
    const controller = new AbortController();
    aiAnalysisRequestRef.current = { id: requestId, controller };
    setShowAiAnalysisModal(true);
    setAiAnalysisLoading(true);
    setAiAnalysisError(null);
    setAiAnalysisRow(null);
    try {
      const res = await axios.get(
        `${window.env.API_URL}/race/${RaceId}/ai-analysis`,
        { timeout: 60000, signal: controller.signal }
      );
      if (aiAnalysisRequestRef.current.id !== requestId) {
        return;
      }
      setAiAnalysisRow(res.data?.data ?? null);
    } catch (error) {
      if (
        aiAnalysisRequestRef.current.id !== requestId ||
        error?.code === "ERR_CANCELED"
      ) {
        return;
      }
      const msg =
        error.response?.data?.message ||
        error.message ||
        "Failed to load analysis";
      setAiAnalysisError(typeof msg === "string" ? msg : JSON.stringify(msg));
    } finally {
      if (aiAnalysisRequestRef.current.id === requestId) {
        aiAnalysisRequestRef.current.controller = null;
        setAiAnalysisLoading(false);
      }
    }
  };

  const closeAiAnalysisModal = () => {
    aiAnalysisRequestRef.current.controller?.abort();
    aiAnalysisRequestRef.current = {
      id: aiAnalysisRequestRef.current.id + 1,
      controller: null,
    };
    setShowAiAnalysisModal(false);
    setAiAnalysisLoading(false);
    setAiAnalysisError(null);
    setAiAnalysisRow(null);
  };

  // The backend runs the analysis in the background (about 3 minutes); this follows the saved row until it finishes.
  const followAiAnalysis = () => {
    clearTimeout(aiPollRef.current);
    const deadline = Date.now() + AI_POLL_LIMIT_MS;
    const checkAgain = () => {
      if (Date.now() < deadline) {
        aiPollRef.current = setTimeout(check, AI_POLL_INTERVAL_MS);
        return;
      }
      setAiLoading(false);
      swal({
        title: "Still running",
        text: "The AI analysis is taking longer than expected. Check View AI analysis later.",
        icon: "warning",
        button: "OK",
      });
    };
    const check = async () => {
      let row;
      try {
        const res = await axios.get(
          `${window.env.API_URL}/race/${RaceId}/ai-analysis`,
          { timeout: 30000 }
        );
        row = res.data?.data;
      } catch (error) {
        checkAgain();
        return;
      }
      if (row?.status === "pending") {
        checkAgain();
        return;
      }
      setAiLoading(false);
      if (row?.status === "success") {
        swal({
          title: "Success",
          text: "AI analysis saved",
          icon: "success",
          button: "OK",
        });
        return;
      }
      swal({
        title: "Error",
        text: row?.errorMessage || "AI analysis failed",
        icon: "error",
        button: "OK",
      });
    };
    checkAgain();
  };

  // Opening the page while a run is in progress keeps the button locked until it finishes.
  useEffect(() => {
    if (!RaceId) return undefined;
    let active = true;
    axios
      .get(`${window.env.API_URL}/race/${RaceId}/ai-analysis`, { timeout: 30000 })
      .then((res) => {
        if (active && res.data?.data?.status === "pending") {
          setAiLoading(true);
          followAiAnalysis();
        }
      })
      .catch(() => {});
    return () => {
      active = false;
      clearTimeout(aiPollRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [RaceId]);

  const applyAiAnalysis = async () => {
    if (!RaceId) return;
    setAiLoading(true);
    try {
      await axios.post(
        `${window.env.API_URL}/race/${RaceId}/ai-analysis/apply`,
        {},
        { timeout: 30000 }
      );
      followAiAnalysis();
    } catch (error) {
      setAiLoading(false);
      const msg =
        error.response?.data?.message ||
        error.message ||
        "Request failed";
      swal({
        title: "Error",
        text: typeof msg === "string" ? msg : JSON.stringify(msg),
        icon: "error",
        button: "OK",
      });
    }
  };

  return (
    <>
      <Modal
        show={showAiAnalysisModal}
        onHide={closeAiAnalysisModal}
        size="xl"
        centered
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>Race AI analysis (by win %)</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {aiAnalysisLoading && <p>Loading…</p>}
          {!aiAnalysisLoading && aiAnalysisError && (
            <p style={{ color: "#c00" }}>{aiAnalysisError}</p>
          )}
          {!aiAnalysisLoading && !aiAnalysisError && aiAnalysisRow && (
            <>
              <p style={{ marginBottom: "12px", fontSize: "14px" }}>
                <strong>Status:</strong> {aiAnalysisRow.status}
                {aiAnalysisRow.llmProvider ? (
                  <>
                    {" "}
                    · <strong>Provider:</strong> {aiAnalysisRow.llmProvider}
                  </>
                ) : null}
                {aiAnalysisRow.llmModel ? (
                  <>
                    {" "}
                    · <strong>Model:</strong> {aiAnalysisRow.llmModel}
                  </>
                ) : null}
                {aiAnalysisRow.createdAt ? (
                  <>
                    {" "}
                    · <strong>Saved:</strong>{" "}
                    {moment(aiAnalysisRow.createdAt).format("YYYY-MM-DD HH:mm")}
                  </>
                ) : null}
              </p>
              {aiAnalysisRow.status !== "success" && (
                <div style={{ marginBottom: "12px" }}>
                  {aiAnalysisRow.errorMessage && (
                    <p>
                      <strong>Error:</strong> {aiAnalysisRow.errorMessage}
                    </p>
                  )}
                  {aiAnalysisRow.validationErrors != null && (
                    <pre style={{ fontSize: "12px", whiteSpace: "pre-wrap" }}>
                      {typeof aiAnalysisRow.validationErrors === "string"
                        ? aiAnalysisRow.validationErrors
                        : JSON.stringify(aiAnalysisRow.validationErrors, null, 2)}
                    </pre>
                  )}
                </div>
              )}
              {aiAnalysisRow.status === "success" && sortedAiHorses.length === 0 && (
                <p>No horse rows in saved analysis.</p>
              )}
              {aiAnalysisRow.status === "success" && sortedAiHorses.length > 0 && (
                <div style={{ overflowX: "auto", maxHeight: "65vh" }}>
                  <table
                    className="table table-sm table-bordered"
                    style={{ fontSize: "13px", marginBottom: 0, minWidth: "max-content" }}
                  >
                    <thead>
                      <tr>
                        <th style={{ color: "#fff" }}>#</th>
                        {aiHorseColumnKeys.map((k) => (
                          <th key={k} style={{ color: "#fff" }}>
                            {labelAiHorseColumn(k)}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {sortedAiHorses.map((h, idx) => (
                        <tr
                          key={`${h.horseName}-${idx}`}
                          style={{ backgroundColor: idx % 2 === 1 ? "#f5f5f5" : "#fff" }}
                        >
                          <td>{idx + 1}</td>
                          {aiHorseColumnKeys.map((k) => (
                            <td key={k}>{formatAiHorseCell(k, h[k])}</td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </>
          )}
        </Modal.Body>
      </Modal>
      <div className="page">
        <div className="rightsidedata">
          <div
            style={{
              marginTop: "30px",
            }}
          >
            <div className="Header ">
              <h4>Horse Details</h4>
              <button className="AddAnother1" onClick={addMore}>
                Add More Horse
              </button>
              <button
                className="AddAnother1"
                type="button"
                disabled={aiLoading || !EditRaceHorse?.length}
                onClick={applyAiAnalysis}
                style={{ marginLeft: "8px" }}
              >
                {aiLoading ? "AI running (about 3 min)..." : "Apply AI analysis"}
              </button>
              <button
                className="AddAnother1"
                type="button"
                disabled={aiAnalysisLoading}
                onClick={openAiAnalysisModal}
                style={{ marginLeft: "8px" }}
              >
                {aiAnalysisLoading ? "Loading…" : "View saved AI analysis"}
              </button>
            </div>

            <div className="horizontal-scroll-wrapper squares" style={{ paddingBottom: "12px" }}>
              <table className="editformtable raceRowsSeparated" style={{ caretColor: "transparent" }}>   <thead >
                <tr >
                  <th>Horse #</th>
                  <th>Gate #</th>
                  <th>Horse</th>
                  <th>Owner Name</th>
                  <th>Trainer</th>
                  <th>Age</th>
                  <th>Jockey</th>
                  <th> Weight</th>
                  <th>Min Weight</th>
                  <th>Race Weight</th>
                  <th>Rating</th>
                  <th>Cap Color</th>
                  <th>Equipment</th>
                  <th>Horse Status</th>
                  <th>Action</th>
                </tr>
              </thead>

                <tbody >
                  <>
                    {!EditRaceHorse ? (
                      <></>
                    ) : (
                      EditRaceHorse.map((item, i) => {
                        return (
                          <tr className="">

                            <td className="myedit">

                              <input
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                value={item.HorseNo}
                                min="1"
                              />

                            </td>

                            <td className="myedit">
                              <input
                                value={item.GateNo === 100 ? "Non Runner" : item.GateNo}
                                readOnly
                              />
                            </td>


                            <td className="myedit">
                              <input
                                value={item.HorseModelIdData1 ? item.HorseModelIdData1.NameEn : ""}
                                readOnly
                              />

                            </td>

                            <td className="myedit">

                              <input
                                placeholder={HorseData.OwnerOnRaceData1 ? item.OwnerOnRaceData1.NameEn : <></>}
                                value={item.OwnerOnRaceData1 ? item.OwnerOnRaceData1.NameEn : <></>}
                                readOnly
                                style={{ width: "120px" }}
                              />

                            </td>

                          <td className="myedit">
                            <span className="inputAddhorse3">
                              <input
                                placeholder="Trainer"
                                value={item?.TrainerOnRaceData1.NameEn}
                                readOnly
                              />
                            </span>
                          </td>

                            
                          <td className="myedit">
                            <span className="inputAddhorse3">
                              <input
                                placeholder="Age"
                                value={moment().diff(moment(item?.HorseModelIdData1.DOB), "years")}
                                readOnly
                              />
                            </span>
                          </td>


                          <td className="myedit">
                              <input
                                value={
                                  item.JockeyOnRaceData1 === null
                                    ? "Non Runner"
                                    : item.JockeyOnRaceData1.NameEn
                                }
                                readOnly
                              />
                            </td>


                            <td className="myedit">

                              <input
                                placeholder={
                                  item.JockeyWeight === null
                                    ? 0
                                    : item.JockeyWeight
                                }
                                value={item.JockeyWeight}
                                readOnly
                              />
                            </td>


                            <td className="myedit">

                              <input
                                placeholder={
                                  item.JockeyWeight === null
                                    ? 0
                                    : item.JockeyWeight
                                }
                                value={item.minweight}
                                readOnly
                              />

                            </td>

                            <td className="myedit">

                              <input
                                placeholder={item.JockeyRaceWeight}
                                value={item.JockeyRaceWeight || ""}
                                readOnly
                              />
                            </td>


                            <td className="myedit">

                              <input
                                type={item.Rating}
                                value={item.Rating}
                                readOnly
                                placeholder="Rating"
                              />

                            </td>

                            <td className="myedit">
                              {item.CapColorData1 ? (
                                <img
                                  src={item.CapColorData1.OwnerSilkColor}
                                  alt=""
                                  style={{ width: "30px", height: "30px" }}
                                />
                              ) : (
                                <></>
                              )}



                            </td>

                            <td className="myedit">
                              <input
                                value={item.EquipmentData1 === null ? "-" : item.EquipmentData1.NameEn}
                                readOnly
                              />

                            </td>

                            <td className="myedit">
                              <input
                                value={item.HorseRunningStatus ? "Active" : "Inactive"}
                                readOnly
                              />
                            </td>
                            <td className="myedit">
                              <button
                                className="removebtnhorse"
                                onClick={() => handleRemove(item._id)}
                              >
                                <ImCross />
                              </button>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </>

                  <div className="sbmtbtndiv"></div>
                </tbody>
              </table>
            </div>
            <div className="RaceButtonDiv">
              {/* <button className="updateButton" onClick={submit}>
                      Add
                    </button> */}

              <button
                className="SubmitButton"
                type="submit"
                onClick={() =>
                  history("/editraceverdict", {
                    state: {
                      RaceId: RaceId,
                    },
                  })
                }
              >
                Edit Verdict
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditRaceHorse;
